import {connect} from 'react-redux'
import {ActionsRow, commons, field, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Alert, Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import {UZIVATELE_FETCH_LIMIT} from "../../actions/subjektActions";
import TablePanel from "../../components/TablePanel";
import SubjektApi from "../../api/gen/cgo/SubjektApi";
import {withRouter} from "react-router";
import UzivatelForm from "../../forms/UzivatelForm";
import NastaveniObjednavkyUzivatelForm from "../../forms/NastaveniObjednavkyUzivatelForm";
import ZmenaHeslaForm from "../../forms/ZmenaHeslaForm";
import OpravneniApi from "../../api/gen/cgo/OpravneniApi";
import {toastr} from "react-redux-toastr";
import {ADMIN_BASE_PATH, UZIVATELE_PATH} from "../../const/routes";
import * as opravneniActions from "../../actions/opravneniActions";
import * as EnumRole from "../../api/gen/cgo/EnumRole";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

/**
 * Stránka administrace - Uživatelé
 */
class UzivatelePage extends Component<WithTranslation> {

    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(subjektActions.fetchUzivateleIfNeeded());
    };

    handleCreateUzivatel = () => {
        const {loggedInUser, t} = this.props;
        let vychoziRole = null;
        if (loggedInUser.data.editaceUzivatelRoleList.length > 0) {
            vychoziRole = loggedInUser.data.editaceUzivatelRoleList[0];
        }
        this.props.dispatch(modal.ModalActions.show(
            UzivatelForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.createUzivatel(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatele());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    role: vychoziRole,
                },
            },
            t('user.new'),
            {size: "md"}
        ));
    };

    handleEditUzivatel = (uzivatel) => {
        const {loggedInUser, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UzivatelForm,
            {
                onSubmit: (data) => {
                    return subjektActions.updateUzivatel(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatele());
                    dispatch(subjektActions.invalidateUzivatelDetail(uzivatel.id));
                    if (loggedInUser.data.id === uzivatel.id) {
                        dispatch(opravneniActions.invalidateLoggedInUser());
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: uzivatel
            },
            t('user.change'),
            {size: "md"}
        ));
    };

    handleEditUzivatelPredvolby = (uzivatel) => {
        const {loggedInUser, zpusobDopravaVychozi, zpusobPlatbaVychozi, pobockaVydejVychozi, notifikaceEmail, notifikaceSms} = uzivatel;
        this.props.dispatch(modal.ModalActions.show(
            NastaveniObjednavkyUzivatelForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateUzivatelPredvolby(data, uzivatel.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatele());
                    dispatch(subjektActions.invalidateUzivatelDetail(uzivatel.id));
                    if (loggedInUser.data.id === uzivatel.id) {
                        dispatch(opravneniActions.invalidateLoggedInUser());
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {zpusobDopravaVychozi, zpusobPlatbaVychozi, pobockaVydejVychozi, notifikaceEmail, notifikaceSms},
                uzivatelId: uzivatel.id
            },
            t('user.preset_change'),
            {size: "md"}
        ));
    };

    handleShowUzivatel = (uzivatel) => {
        this.props.history.push(`/${ADMIN_BASE_PATH}/${UZIVATELE_PATH}/${uzivatel.id}`);
    };

    handleFulltextChange = (value) => {
        const {uzivateleList} = this.props;
        this.props.dispatch(subjektActions.filterUzivatele({
            ...uzivateleList.filter,
            fulltext: value
        }, false));
    };

    handleClearFulltext = () => {
        this.handleFulltextChange("");
    };

    handleEditUzivatelHeslo = (uzivatel) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZmenaHeslaForm,
            {
                onSubmit: (data) => {
                    OpravneniApi.changePassword(uzivatel.id, data.oldPassword, data.password).then(() => {
                        toastr.success('Heslo změněno');
                    });
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('user.password_change',{username: uzivatel.zobrazJmeno}),
            {size: "md"}
        ));
    };

    handleResetUzivatelHeslo = (uzivatel) => {
        const {t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('user.password_reset'),
                t('user.password_reset_info',{username: uzivatel.zobrazJmeno}),
                () => {
                    OpravneniApi.resetPassword(uzivatel.id).then(() => {
                        toastr.success('Heslo resetováno');
                    });
                },
                null,
                t('confirm')
            )
        );
    };

    fetchUserRights = (uzivatelId) => {
        if (!this.state[uzivatelId]) {
            SubjektApi.getUzivatelRights(uzivatelId).then(rights => {
                this.setState({[uzivatelId]: rights});
            });
        }
    };

    renderContextMenu = (uzivatel) => {
        const {t} = this.props;
        const rights = this.state[uzivatel.id];
        const canUpravitUdaje = rights && rights.uzivatelEdit;
        return <FixedDropDownButton onToggle={this.fetchUserRights.bind(this, uzivatel.id)} color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleShowUzivatel.bind(this, uzivatel))}>{t('show_detail')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditUzivatel.bind(this, uzivatel))} disabled={!canUpravitUdaje}>{t('edit_details')}</DropdownItem>
            <DropdownItem key="2" onClick={sinkEvent(this.handleEditUzivatelPredvolby.bind(this, uzivatel))}>{t('edit_preferences')}</DropdownItem>
            <DropdownItem key="3" onClick={sinkEvent(this.handleEditUzivatelHeslo.bind(this, uzivatel))}>{t('change_password')}</DropdownItem>
            <DropdownItem key="4" onClick={sinkEvent(this.handleResetUzivatelHeslo.bind(this, uzivatel))}>{t('reset_password')}</DropdownItem>
        </FixedDropDownButton>
    };

    render() {
        const {loggedInUser, uzivateleList, t} = this.props;

        let content;
        if (!loggedInUser.fetched || !uzivateleList.fetched) {
            content = <Loader/>;
        }

        if (uzivateleList.rows.length !== 0) {
            content = uzivateleList.rows.map((uzivatel) => {
                return <CardBody key={uzivatel.id}>
                    <ActionsRow actions={this.renderContextMenu(uzivatel)} onClick={this.handleShowUzivatel.bind(this, uzivatel)}>
                        <Row>
                            <Col className="overflow" xs={1}>{uzivatel.titulPr}</Col>
                            <Col className="overflow" xs={2}>{uzivatel.jmeno}</Col>
                            <Col className="overflow" xs={2}>{uzivatel.prijmeni}</Col>
                            <Col className="overflow" xs={1}>{uzivatel.titulZa}</Col>
                            <Col className="overflow" xs={2}>{uzivatel.loginName}</Col>
                            <Col className="overflow" xs={2}>{uzivatel.email}</Col>
                            <Col className="overflow" xs={2}>{uzivatel.telefon}</Col>
                        </Row>
                    </ActionsRow>
                </CardBody>;
            });
        } else {
            content = <CardBody>{t('user.none')}</CardBody>
        }

        const extRezim = loggedInUser.data.extSystemRezim;
        const role = loggedInUser.data.role;

        return <AdminPage
            title={t('user.many')}
            subtitle={t('user.many')}
            content={
                <div>
                    <Row>
                        <Col xs={9}>
                            <ButtonToolbar>
                                {role === EnumRole.ADMIN && !extRezim && <Button color="primary" onClick={this.handleCreateUzivatel}>{t('new_m')}</Button>}
                            </ButtonToolbar>
                        </Col>
                        <Col xs={3}>
                            <field.Search value={uzivateleList.filter.fulltext} onChange={this.handleFulltextChange} placeholder={t('user.filter')} />
                        </Col>
                    </Row>
                    {uzivateleList.filter.fulltext &&
                    <Alert color="info" isOpen toggle={this.handleClearFulltext}>{t('search_result',{vyraz: uzivateleList.filter.fulltext})}</Alert>}
                    {uzivateleList.rows.length >= UZIVATELE_FETCH_LIMIT &&
                    <Alert color="info">{t('users_search_result',{count: UZIVATELE_FETCH_LIMIT})}</Alert>}
                    <TablePanel header={
                        <Row>
                            <Col xs={1}>{t('title_before')}</Col>
                            <Col xs={2}>{t('firstname')}</Col>
                            <Col xs={2}>{t('surname')}</Col>
                            <Col xs={1}>{t('title_after')}</Col>
                            <Col xs={2}>{t('login')}</Col>
                            <Col xs={2}>{t('email')}</Col>
                            <Col xs={2}>{t('phone')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        uzivateleList: utils.storeFromArea(state, subjektActions.UZIVATELE_LIST_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(UzivatelePage)));

